import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewFieldSectionsToggles } = formModuleLenses

export default (state, { moduleId }) => viewFieldSectionsToggles(
	moduleId, moduleDescriptions,
)
